var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.99998C1 10.0506 1.20693 11.0908 1.60896 12.0614C2.011 13.032 2.60028 13.914 3.34315 14.6568C4.08601 15.3997 4.96793 15.989 5.93853 16.391C6.90914 16.793 7.94943 17 9 17C10.0506 17 11.0909 16.793 12.0615 16.391C13.0321 15.989 13.914 15.3997 14.6569 14.6568C15.3997 13.914 15.989 13.032 16.391 12.0614C16.7931 11.0908 17 10.0506 17 8.99998C17 7.94941 16.7931 6.90912 16.391 5.93852C15.989 4.96792 15.3997 4.08601 14.6569 3.34314C13.914 2.60027 13.0321 2.011 12.0615 1.60896C11.0909 1.20693 10.0506 1 9 1C7.94943 1 6.90914 1.20693 5.93853 1.60896C4.96793 2.011 4.08601 2.60027 3.34315 3.34314C2.60028 4.08601 2.011 4.96792 1.60896 5.93852C1.20693 6.90912 1 7.94941 1 8.99998Z",
    stroke: "#4F5662",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 9.00006C7.22266 9.47156 7.40996 9.92374 7.74336 10.2571C8.07675 10.5905 8.52894 10.7778 9.00043 10.7778M7.22266 9.00006C7.22266 8.52857 7.40996 8.07639 7.74336 7.74299C8.07675 7.40959 8.52894 7.22229 9.00043 7.22229C9.47193 7.22229 9.92411 7.40959 10.2575 7.74299C10.5909 8.07639 10.7782 8.52857 10.7782 9.00006M7.22266 9.00006L1.22266 7.22229M9.00043 10.7778C9.47193 10.7778 9.92411 10.5905 10.2575 10.2571C10.5909 9.92374 10.7782 9.47156 10.7782 9.00006M9.00043 10.7778V17M10.7782 9.00006L16.7782 7.22229",
    stroke: "#4F5662",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriver);
export default __webpack_public_path__ + "static/media/icon-driver.6d8deb11d3591c07d711f71c831a44a8.svg";
export { ForwardRef as ReactComponent };